import React from 'react';
import DrawerForm from 'components/DrawerForm';
import { Input, Form, Radio, Button, Space } from 'antd';
import ColorPicker from 'components/ColorPicker';
import QueryBuilderInput from 'components/QueryBuilder/QueryBuilderInput';
import { COMPARE_PERIOD, getDefaultDateRange } from 'shared/constants/date';
import PreviewDates, { PeriodLabel } from 'components/DateRangePicker/date-preview';
import DateRangePickerModal from 'components/DateRangePicker/date-range-picker-modal';

const dateRangeOptions = [
  { label: 'Main', value: 'main' },
  { label: 'Previous period', value: COMPARE_PERIOD.PERIOD },
  { label: 'Previous year', value: COMPARE_PERIOD.YEAR },
  { label: 'Custom', value: 'custom' },
];

const DateRangeInput = ({ value, onChange, globalDateRange }) => {
  const [showPicker, setShowPicker] = React.useState(false);

  let selectedDateRangeOption = 'main';
  let dateRange;

  if (value) {
    if (value.compareToPrevious) {
      dateRange = { ...globalDateRange, compareToPrevious: true, comparePeriod: value.comparePeriod };
      selectedDateRangeOption = value.comparePeriod;
    } else {
      dateRange = value;
      selectedDateRangeOption = 'custom';
    }
  }

  const onDateRangeChange = (updated) => {
    onChange({ ...updated, compareToPrevious: false });
    setShowPicker(false);
  };

  const onDateRangeOptionChange = (e) => {
    const updated = e.target.value;
    if (updated === 'main') {
      onChange(null);
    } else if (updated === 'custom') {
      setShowPicker(true);
    } else if (updated === COMPARE_PERIOD.PERIOD) {
      onChange(getDefaultDateRange({ compareToPrevious: true }));
    } else if (updated === COMPARE_PERIOD.YEAR) {
      onChange(getDefaultDateRange({ compareToPrevious: true, comparePeriod: COMPARE_PERIOD.YEAR }));
    }
  };

  return (
    <>
      <Radio.Group
        options={dateRangeOptions.map(o => ({
          ...o,
          style: { width: '100%' },
          label: (
            <Space>
              {o.label}
              {o.value === 'main' && <PreviewDates dateRange={globalDateRange} mainOnly />}
              {o.value === COMPARE_PERIOD.PERIOD && <PreviewDates dateRange={{ ...globalDateRange, compareToPrevious: true }} compareOnly />}
              {o.value === COMPARE_PERIOD.YEAR && <PreviewDates dateRange={{ ...globalDateRange, compareToPrevious: true, comparePeriod: COMPARE_PERIOD.YEAR }} compareOnly />}
            </Space>
          ),
        }))}
        value={selectedDateRangeOption}
        onChange={onDateRangeOptionChange}
      />
      {selectedDateRangeOption === 'custom' && (
        <Button style={{ marginTop: '1em' }} onClick={() => setShowPicker(true)}>
          <PeriodLabel dateRange={dateRange} />
          <PreviewDates dateRange={dateRange} mainOnly />
        </Button>
      )}

      <DateRangePickerModal
        open={showPicker}
        onChange={onDateRangeChange}
        onCancel={() => setShowPicker(false)}
        value={value}
        defaultValue={null}
        allowCompare={false}
      />
    </>
  );
};

const EditSegmentDrawer = ({ open, segment, onSubmit, onRemove, onCancel, globalDateRange }) => (
  <DrawerForm
    open={open}
    onSubmit={onSubmit}
    onCancel={onCancel}
    title={segment?.title ? `Edit segment ${segment?.title}` : 'Edit segment'}
    initialValues={segment}
    onRemove={onRemove}
  >
    <Form.Item name="id" hidden>
      <Input />
    </Form.Item>
    <Form.Item label="Title" name="title" rules={[{ required: true }]}>
      <Input />
    </Form.Item>
    <Form.Item label="Color" name="color">
      <ColorPicker />
    </Form.Item>
    <Form.Item label="Date range" name="dateRangeConfig">
      <DateRangeInput globalDateRange={globalDateRange} />
    </Form.Item>
    <Form.Item label="Query" name="query">
      <QueryBuilderInput />
    </Form.Item>
  </DrawerForm>
);

export default EditSegmentDrawer;
